import React from 'react';
import { Col } from 'react-bootstrap';
export interface ITabContainerProps {
  title?: string;
  subtitle?: string;
  description?: string;
  titleIcon?: React.ReactNode;
  children: React.ReactNode;
}
const TabContainer = (props: ITabContainerProps): React.ReactElement => {
  return (
    <Col>
      <div className="k-tabstrip-wrapper">
        {props.title && <h3 className="mb-0">{props.title}</h3>}
        {props.subtitle && <h4>{props.subtitle}</h4>}
        {props.description && <p>{props.description}</p>}
        {props.children}
      </div>
    </Col>
  );
};
export default TabContainer;
